import React from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import { translationService } from "../../services/translation/TranslationService";
import Language from "../../services/translation/language";

interface TermsAndConditionsProps {
  textKeyBeforeLinks?: string;
  textKeyAfterLinks?: string;
}

export const TermsAndConditions = observer((props: TermsAndConditionsProps) => {
  return (
    <div className="terms-and-conditions-container">
      {props.textKeyBeforeLinks ? translationService.translate(props.textKeyBeforeLinks) : ""}
      <Link
        to={{
          pathname:
            translationService.language === Language.english
              ? "https://esic-sarida.cloud/en/general-terms-and-conditions/"
              : "https://esic-sarida.cloud/agb/",
        }}
        target="_blank"
      >
        {translationService.translate("general.terms-and-conditions")}
      </Link>
      <span> & </span>
      <Link
        to={{
          pathname:
            translationService.language === Language.english
              ? "https://esic-sarida.cloud/en/imprint/"
              : "https://esic-sarida.cloud/impressum/",
        }}
        target="_blank"
      >
        {translationService.translate("general.privacy-policy")}
      </Link>
      {props.textKeyAfterLinks ? translationService.translate(props.textKeyAfterLinks) : ""}
    </div>
  );
});
